import type { ReactNode } from 'react';

type SurveyTypePickerProps = {
  value: string;
  onChange: (surveyType: string) => void;
};

const OPTIONS: Array<{
  value: string;
  title: string;
  description: string;
  preview: ReactNode;
}> = [
  {
    value: 'Csat',
    title: 'CSAT',
    description: 'Satisfação do atendimento — escala curta (ex.: estrelas 1–5).',
    preview: (
      <div className="flex gap-0.5 text-amber-400" aria-hidden="true">
        {'★★★★☆'.split('').map((star, index) => (
          <span key={index} className="text-sm leading-none">
            {star}
          </span>
        ))}
      </div>
    ),
  },
  {
    value: 'Nps',
    title: 'NPS',
    description: 'Recomendação — tipicamente nota de 0 a 10.',
    preview: (
      <div className="flex gap-0.5" aria-hidden="true">
        {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((n) => (
          <span
            key={n}
            className={`flex h-4 w-4 items-center justify-center rounded text-[9px] font-medium ${
              n === 9 ? 'bg-primary-600 text-white' : 'bg-secondary-100 text-secondary-600'
            }`}
          >
            {n}
          </span>
        ))}
      </div>
    ),
  },
];

export function SurveyTypePicker({ value, onChange }: SurveyTypePickerProps) {
  return (
    <div className="grid gap-2 sm:grid-cols-2" role="radiogroup" aria-label="Tipo de pesquisa">
      {OPTIONS.map((option) => {
        const selected = value === option.value;
        return (
          <button
            key={option.value}
            type="button"
            role="radio"
            aria-checked={selected}
            onClick={() => onChange(option.value)}
            className={[
              'rounded-lg border px-3 py-2.5 text-left transition-colors',
              selected
                ? 'border-primary-500 bg-primary-50 ring-1 ring-primary-500'
                : 'border-secondary-200 bg-white hover:border-secondary-300 hover:bg-secondary-50',
            ].join(' ')}
          >
            <p className="text-sm font-medium text-secondary-900">{option.title}</p>
            <p className="mt-0.5 text-[11px] leading-snug text-secondary-500">
              {option.description}
            </p>
            <div className="mt-2">{option.preview}</div>
          </button>
        );
      })}
    </div>
  );
}
